import { AuthorFields, calcDateSpanDescription, Document, FullAuthored, PostTypes } from 'model';
import React from 'react';
import { ProfilePic } from '../components/ProfilePic';
import { IconBusiness, IconLocation, IconPoll, IconQuestion } from './QuirkIcons';
import { TopicButton } from './TopicButton';
// eslint-disable-next-line css-modules/no-unused-class
import shareStyles from '../styles/Shared.module.css';
// eslint-disable-next-line css-modules/no-unused-class
import styles from './AuthorHeader.module.css';

export const AuthorHeader = <T extends Document & AuthorFields>({
	authoredItem,
	topic,
	postType,
	isDetail = false,
	authorTestid,
	topicTestid
}: {
	authoredItem: FullAuthored<T>;
	topic?: string;
	postType?: PostTypes;
	showEdited?: boolean;
	isDetail?: boolean;
	authorTestid?: string;
	topicTestid?: string;
}): ReturnType<React.FC<{ author: FullAuthored<T> }>> => {
	return (
		<div className={styles.authorHeader}>
			<ProfilePic user={authoredItem.fullAuthor} size={'small'} />
			<div className={shareStyles.authorHeaderDetailsContainer}>
				<div className={shareStyles.name} data-testid={authorTestid}>
					{authoredItem && authoredItem.author && authoredItem.fullAuthor.username}
				</div>
				<div className={shareStyles.dateContainer}>
					{postType === 'communityQuestion' && (
						<div className={styles.iconContainer}>
							<IconQuestion size="small" />
						</div>
					)}
					{postType === 'poll' && (
						<div className={styles.iconContainer}>
							<IconPoll size="small" />
						</div>
					)}
					{postType === 'businessCheckIn' && (
						<div className={styles.iconContainer}>
							<IconLocation size="small" />
						</div>
					)}
					{postType === 'businessPost' && (
						<div className={styles.iconContainer}>
							<IconBusiness size="small" />
						</div>
					)}
					<div className={shareStyles.topicAndDateHolder}>
						<span className={shareStyles.time}>{calcDateSpanDescription(authoredItem.updated)}</span>
						{topic && <TopicButton topic={topic} testId={topicTestid} />}
					</div>
				</div>
			</div>
		</div>
	);
};
